import {ChipOwnProps} from '@mui/material'

export type ChipsToggleOption<TOptionValue extends string> = {
  value: TOptionValue
  label: string
  icon?: ChipOwnProps['icon']
}
